<template>
  <div class="frame" :class="$mq">
    <h1>{{ $t(label("title")) }}</h1>
    <div>
      <p>{{ deliveryDate }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment"

export default {
  name: "DeliveryDate",
  computed: {
    deliveryDate() {
      return moment().add(25, 'days').add(1, 'month').startOf('month').format('DD-MM-YYYY');
    }
  },
  methods: {
    label(value) {
      return "Comeback.DeliveryDate." + value
    }
  }

}
</script>

<style scoped>

p {
  text-align: left;
}

h3 {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Comeback/ColdLoss/DeliveryDate.vue